import type {ChangeEvent, ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {ExtendedControlInputProps} from '../../slider-control.types';
import {parseAndClamp} from '../../slider-control.utils';
import styles from '../../slider-control.module.scss';

export function ExtendedControlInput({
  ariaLabel,
  iconClass,
  inputClassName,
  value,
  min,
  max,
  step,
  isSelected,
  onFocus,
  onBlur,
  onChange,
}: ExtendedControlInputProps): ReactElement {
  function handleChange(e: ChangeEvent<HTMLInputElement>): void {
    const parsed = parseAndClamp(e.target.value, min, max);
    onChange(parsed);
  }
  return (
    <div className={`${styles.extendedProperty} ${isSelected ? styles.extendedPropertySelected : ''}`}>
      <div className={styles.extendedPropertyIcon}>
        <Icon aria-hidden icon={iconClass} size={IconSize.SIZE_ICON_16} />
      </div>
      <input
        aria-label={ariaLabel}
        className={[styles.extendedPropertyInput, inputClassName].filter(Boolean).join(' ')}
        max={max}
        min={min}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        step={step}
        type="number"
        value={value}
      />
    </div>
  );
}
